import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"
import * as CustomInput from "../util/CustomInput.ts";

import ApiServer from "../ApiServer.ts";
import FizConfig from "../FizConfig.ts";
import {EventStore} from "../server/EventStore.ts";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import * as libUrl from "../lib/url.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import "../list/taskQuickAdd.ts";
import {TaskListCache,MetaTaskCache} from "../server/objects/TaskBeans.ts"

import Icons from "../svg/Icons.ts";

import TPL_SLOTCONTENT from "../mealplanner/slotcontent.mustache"
import TPL_CHOOSEFIRSTDAY from "../mealplanner/modal_firstday.mustache"
import TPL_PLANNING from "../mealplanner/planning.mustache";

import {apiCustommplist,dishSyncCache,getWeekRange, recipeSyncCache,MealplannerSettingsCache, updateMealplannerSettings} from "./mealplannerApi.ts"
import * as mealplannerModal from "./mealplannerModal.ts"
import { registerDragStart } from "../lib/FileUtils.ts";
import { localGet, localSet } from "../lib/Storage.ts";
import { initPaneRight } from "../util/PaneRight.ts";
import "../util/taskutil.ts"
import * as recipeModal from "./recipeModal.ts";



var
  range,daysByKey,selectedCalendarIds,defaultList;

function mealplannerrightpane(pane ?:string){
  if(pane===undefined){
    pane = localGet('mealplanner.rightpane')|| 'recipe'
  }
  localSet('mealplanner.rightpane',pane)
  document.querySelectorAll(".pane-selector>*").forEach(node=>{
    var addClass = node.getAttribute('data-fw-onclick')==='mealplannerrightpane|'+pane
    if(addClass){
      node.classList.add('selected')
    }else{
      node.classList.remove('selected')
    }
  })
  document.getElementById('task-list').style.display = pane==='task'?'block':'none';
  document.getElementById('recipe-list').style.display = pane==='recipe'?'block':'none';
}

actionMenu.register({
  async mppickdate(){
    var settingsPerFamily = FwDatas.getSettingsPerFamily() ;
    return {'pickdate':{
      date:range.start,
      firstDayOfWeek:settingsPerFamily.mealplannerFirstDayOfWeek,
      onpickdate:(date)=>{
        range = getWeekRange(date)
        displayWeek()
      }
    }}
  },
  async mpsettingsmenu(){
    var
      menu = [],
      settings = await MealplannerSettingsCache.need(),
      settingsPerFamily = FwDatas.getSettingsPerFamily() ;

    if(settingsPerFamily.mealplannerFirstDayOfWeek!==7 && settingsPerFamily.mealplannerFirstDayOfWeek!==6){
      if(settings.showWeekEnd){
        menu.push({onclick:'mpsettingsWE|hide',svg:Icons.calendar.ic_show_weekend,i18nkey:'mp.WEhide'})
      }else{
        menu.push({onclick:'mpsettingsWE|show',svg:Icons.calendar.ic_show_weekend,i18nkey:'mp.WEshow'})
      }
    }else{
      if(settings.showWeekEnd){
        menu.push({onclick:'mpsettingsshowWeekEnddisabled',opacity:0.5,svg:Icons.calendar.ic_show_weekend,i18nkey:'mp.WEhide'})
      }else{
        menu.push({onclick:'mpsettingsshowWeekEnddisabled',opacity:0.5,svg:Icons.calendar.ic_show_weekend,i18nkey:'mp.WEshow'})
      }
    }

    menu.push(
      {onclick:'mpsettings',svg:Icons.clock.ic_access_time,i18nkey:'mp.manage'},
      {onclick:'mpsettingsfirstdayofweek',svg:Icons.ic_time_start,i18nkey:'calendars.settingsweekbegin'},
      {html:'<hr style="margin: 8px 0px;"/>'},
      {onclick:'mpaddtolistopen',svg:Icons.ic_add_shopping_cart,i18nkey:'mp.exporttolist'},
      {onclick:'mpcopyweek',svg:Icons.ic_duplicate,i18nkey:'mp.copyweek'},
      settings.canClear?{onclick:'mpclear',color:'var(--red)',svg:Icons.ic_delete,i18nkey:'mp.clear'}:{html:''},
      {html:'<hr style="margin: 8px 0px;"/>'},
      {onclick:'mpshare',svg:Icons.ic_export,i18nkey:'mp.share'},
      {onclick:'print',svg:Icons.ic_print,i18nkey:'actions.print'}
    )
    return {'menu':menu}
  },
  async mealplannerlist(){
    return {'menu':(await TaskListCache.need()).map(tasklist=>{
      var svgend = defaultList.metaId===tasklist.metaId?Icons.ic_checkmark:undefined
      return {onclick:'mppicklist|'+tasklist.metaId,svg:tasklist.iconsimple,title:tasklist.name,svgend}
    })}
  },
  mprecipemenu(){
    const
      metaId = Html.getDomMetaId(this),
      recipe = FwDatas.get(metaId),
      menu = [];
    if(recipe.isMealSuggestion){
      menu.push({svg:Icons.ic_eye_off,i18nkey:"mp.actions.suggestionremove",onclick:'mpsuggestion|false'})
    }else{
      menu.push({svg:Icons.ic_eye,i18nkey:"mp.actions.suggestionputback",onclick:'mpsuggestion|true'})
    }
    menu.push({svg:Icons.ic_add_shopping_cart,i18nkey:"mp.addtolist",onclick:'mpadditemtolist'})

    menu.push({svg:Icons.ic_edit,i18nkey:"actions.edit",onclick:'mprecipeedit'})
    return {menu}
  }
})


Html.registerDom({
  mealplannerrightpane,
  mpsuggestion(isMealSuggestion){
    const
      metaId = Html.getDomMetaId(this),
      recipe = FwDatas.get(metaId);
      recipe.isMealSuggestion = isMealSuggestion==='true';
    ApiServer.mprecipeput(recipe).then(recipe=>{
      modal.toastDone(recipe.isMealSuggestion?"mp.actions.suggestionputbackdone":"mp.actions.suggestionremovedone")
    });
    amplify.publish("recipeNeedRefresh");
  },

  async mpsettingsfirstdayofweek(){
    const settings = await MealplannerSettingsCache.need()
    var
      weekdays = DateUtils.getWeekDays();

    if(!settings.showWeekEnd){
      weekdays = weekdays.filter(day=>day.index!==7 && day.index!==6)
    }

    modal.openDomModal(TPL_CHOOSEFIRSTDAY,{
      settings:FwDatas.getSettingsPerFamily(),
      weekdays:weekdays
    })
  },
  mpsetfirstday(day){
    modal.closeDomModal();
    var
      settings = FwDatas.getSettingsPerFamily();
    settings.mealplannerFirstDayOfWeek = day;
    ApiServer.settingssetperfamily(settings,function(result){
      FwDatas.setSettingsPerFamily(result);
      range = undefined;
      displayWeek()
    });

  },
  mealadd(){
    const dishNodes = document.querySelectorAll('.mp-dish');
    if(dishNodes.length){
      const lastDish = dishNodes[dishNodes.length - 1];
      const nextSlot = DomTool.nextSlotDom(lastDish);
      if(nextSlot) nextSlot.click();
    }else{
      const firstSlot = document.querySelector<HTMLElement>('.mp-slot');
      if(firstSlot) firstSlot.click();
    }
  },
  async mptooglecal(){
    const settings = await MealplannerSettingsCache.need()
    settings.viewCalendar = !settings.viewCalendar;
    updateMealplannerSettings(settings);
    modal.closeDomModal()
    displayWeek();
  },
  async mpsettingsWE(p){
    const settings = await MealplannerSettingsCache.need()
    settings.showWeekEnd = (p==="show");
    updateMealplannerSettings(settings);
    modal.closeDomModal()
    displayWeek();
  },
  mpprevweek(){
    amplify.publish('mpprevweek')
  },
  mpnextweek(){
    amplify.publish('mpnextweek')
  },
  mpsettingsshowWeekEnddisabled(){
    modal.toast({emoji:'⚠️',text:'mp.settingsshowWeekEnddisabled'},0)
  },
  mptoday(){
    range = undefined;
    displayWeek()
  },
  mppicklist(metaId){
    defaultList = FwDatas.get(metaId);
    amplify.publish("taskNeedRefresh");
  },
  async mpsettings(){
    var changed = await mealplannerModal.modalmealplannersettings();
    if(changed){
      displayWeek()
    }
  },
  mpcopyweek(){
    mealplannerModal.openCopyWeek(range.start,range.prev);
  },
  async mpclear(){
    if(!await modal.confirmDelete("mp.confirmdeleteweek")) return;

    ApiServer.mpclear(
        DateUtils.forInputDate(range.start),
        DateUtils.forInputDate(range.end)
        );
    dishSyncCache.invalidate();
    displayWeek();


  },
  mpaddtolistopen(){
    shopModal(range)
  },
  mpaddtolist(){
    const form = this.closest('form');
    if(!form) return;

    const shopList = [];
    const selectEl = form.querySelector('select') as HTMLSelectElement;
    const listId = selectEl?.value;

    form.querySelectorAll('[data-dishId]').forEach((dishNode: HTMLElement) => {
      const toShop = new ApiServer.types.ShoppingIngredientInputBean({
        dishMetaId: dishNode.getAttribute('data-dishId'),
        ingredientList: []
      });

      const ingredientCheckboxes = dishNode.querySelectorAll('.mp-dish-ingredient');
      if(ingredientCheckboxes.length === 0){
        toShop.ingredientList = null;
      }else{
        dishNode.querySelectorAll<HTMLInputElement>('.mp-dish-ingredient:checked').forEach(checkbox => {
          toShop.ingredientList.push(checkbox.value);
        });
      }
      if(dishNode.querySelectorAll(':checked').length){
        shopList.push(toShop);
      }
    });
    if(shopList.length>0){
      ApiServer.mpadditemtolist(shopList,listId);
      defaultList = FwDatas.get(listId);
      amplify.publish("taskNeedRefresh");
    }
    modal.closeDomModal();
  },

  mpadditemtolist(){
    shopModal(null,[FwDatas.get(Html.getDomMetaId(this))]);
  },
  mpoptionaladd(){
    const opt = document.querySelectorAll('.mpoptional');
    if(opt.length === 1){
      this.style.display = 'none';
    }
    const firstOpt = opt[0];
    if(firstOpt){
      firstOpt.classList.remove('mpoptional');
      (firstOpt as HTMLElement).style.display = '';
      const checkbox = firstOpt.querySelector("[data-widget='widget/form/checkbox']");
      if(checkbox) (checkbox as HTMLElement).click();
    }
  },
  mpshare(){
    ApiServer.mpsharedlink(DateUtils.forInputDate(range.start), DateUtils.forInputDate(range.end),function(bean){
      import("../modal/dialog_share.mustache").then(function(TPL){
        modal.openDomModal(TPL,{title: 'mp.share',message:'mp.sharetext',link:bean.link,pictureUrl:FwDatas.getFamily().coverUri});
      })
    })
  },
  mpclick(metaId){
    amplify.publish('mpclick',metaId||Html.getDomMetaId(this))
  },
  mprecipeedit(focus){
    libLocation.goTo(libUrl.addParams(INR.URL.RECIPEBOX,{
      mode:"edit",
      id:Html.getDomMetaId(this),
      focus:focus?focus:undefined
    }));
  },
  mprecipeview(){
    libLocation.goTo(libUrl.addParams(INR.URL.RECIPEBOX,{
      id:Html.getDomMetaId(this)
    }));
  },
  mpstar(){
    const recipe = FwDatas.get(Html.getDomMetaId(this));
    recipe.setFavorite(true);

    const metaIdNode = Html.getDomMetaIdNode(this);
    ApiServer.mprecipeput(recipe,item=>{
      Object.assign(FwDatas.get(item.metaId),item);
      const starBtn = metaIdNode.querySelector<HTMLElement>('[data-fw-onclick=mpstar]:last-of-type');
      if(starBtn) refreshMood(starBtn,item);
    });
  },
  mpunstar(){
    const recipe = FwDatas.get(Html.getDomMetaId(this));
    recipe.setFavorite(false);

    const metaIdNode = Html.getDomMetaIdNode(this);
    ApiServer.mprecipeput(recipe,item=>{
      Object.assign(FwDatas.get(item.metaId),item);
      const unstarBtn = metaIdNode.querySelector<HTMLElement>('[data-fw-onclick=mpunstar]:last-of-type');
      if(unstarBtn) refreshMood(unstarBtn,item);
    });
  },
  mpdelete(){
    const dishNode = this.parentElement;
    if(!dishNode) return;

    const slotNode = dishNode.closest('.mp-slot') as HTMLElement;
    if(!slotNode) return;

    const dishType = slotNode.getAttribute('dishTypeEnum');
    const dayKey = slotNode.parentElement?.getAttribute('date');
    if(!dishType || !dayKey) return;

    const slotDatas = daysByKey[dayKey].dishByType[dishType];
    const dishMetaId = Html.getDomMetaId(dishNode);

    slotDatas.removeMetaId(dishMetaId);
    dishNode.remove();
    ApiServer.metadelete([dishMetaId]);
    dishSyncCache.invalidate();
  }

})

function refreshMood(node: HTMLElement,item){
  import("../mealplanner/recipeMood.mustache").then(function(TPL){
    const newNode = Html.replaceWithSingleDom(node as HTMLElement,TPL,item);
    newNode.classList.add("animated", "bounceIn");
  })
}

function shopModal(range,dishes){
  import("../mealplanner/modal_shopit.mustache").then(function(TPL){

    ApiServer.loadTaskAndList(async function(lists,freshlistsById,tasks,freshtasksById,categoryList){
      if(lists.length===0){
        modal.toast({emoji:"🧐",text:"catsystem.toastnolist"})
        return;
      }
      if(defaultList===undefined){
        var idx = lists.findIndex(list=>list.systemId===-10);
        defaultList = lists[idx];
      }
      var theModal;
      if(range){
        dishes = (await apiCustommplist(range)).list
      }

      dishes.forEach(dish=>{
        //if it is not a dish but a recipe
        if(dish instanceof ApiServer.types.DishBean){
          dish.ingredientsList = FwDatas.get(dish.recipeId).ingredientsList
        }
      })


      function updateTextButton(){
        const button = theModal.querySelector('button[data-fw-onclick=mpaddtolist]');
        const checkedCount = theModal.querySelectorAll('input:checked').length;
        if(button) button.textContent = i18n.get('mp.addNitem', checkedCount);
      }
      if(range){
        let displayEndDay = new Date(range.end.getTime()-1)
        range = {start:range.start,end:displayEndDay}
      }
      theModal = modal.openDomModal(TPL,{range:range,lists:lists,listId:defaultList.metaId,dishes:dishes});
      theModal.addEventListener('click', updateTextButton);

      const dateInputs = theModal.querySelectorAll('input[type=date]');
      dateInputs.forEach(input => {
        input.addEventListener('blur', function(event){
          const startInput = theModal.querySelector('input[name=start]') as HTMLInputElement;
          const endInput = theModal.querySelector('input[name=end]') as HTMLInputElement;
          var
            startDate = CustomInput.getDateValue(startInput),
            endDate = CustomInput.getDateValue(endInput);
          if(endDate<startDate){
            const form = theModal.querySelector('form') as HTMLFormElement;
            form.reset();
            modal.oops('mp.pickdateinvalid')
            return;
          }
          endDate.setDate(endDate.getDate()+1);

          apiCustommplist({start:startDate,end:endDate}).then(mplistResponse=>{
            dishes = mplistResponse.list;
            dishes.forEach(dish=>{
              dish.ingredientsList = FwDatas.get(dish.recipeId).ingredientsList
            })
            import("../mealplanner/modal_shopit_content.mustache").then(TPL_content=>{
              Html.setHtml(document.getElementById('shopitlist'),TPL_content,{dishes:dishes})
              updateTextButton();
            })
          })
        })
      });
      updateTextButton()
    })
  });
}

async function displayWeek(){
  if(range===undefined){
    range = getWeekRange(new Date())
  }

  const weekdisplayEl = document.getElementById('weekdisplay');
  if(weekdisplayEl) weekdisplayEl.innerHTML = range.name;
  var dishList = await apiCustommplist(range),
  settings = await MealplannerSettingsCache.need();
  daysByKey = dishList.daysByKey;


  if(settings.viewCalendar){
    //TODO convert that to promise
    await EventStore.loadEventsBySync(selectedCalendarIds,[],{start:range.start,end:range.end}).then(events=>{
      events.forEach(function(event){
        var
          dayKey = DateUtils.forInputDate(event.start),
          day = daysByKey[dayKey],
          title = event.title;

        if(day){
          if(!event.allDay){
            title = title + ' '+DateUtils.format(event.start,'LT')
          }
          day.events.push({color:event.color||FizConfig.defaultColor,title:title,metaId:event.metaId});
        }
      })

    });
  }
  ApiServer.aftergroup(function(){
    Html.setHtml(document.getElementById('planner-pane'),TPL_PLANNING,{days:dishList.days,settings:settings});
  })


}
INR.onPage(INR.URL.MEALPLANNER,async function(){
  //can be accessed only by premium users
  if(FwDatas.getPermission('mealPlannerFlag')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }
  selectedCalendarIds = (await EventStore.getSelectedCalendarIds()).filter(calendarMetaId=>calendarMetaId.indexOf('calendarMealPlanner/')!==0)

  displayWeek()
  initPaneRight()
  mealplannerrightpane()

  INR.subscribe("dishChange eventDeleted eventUpdated",function(){
    displayWeek()
  })
  INR.subscribe("taskRefreshed",refreshTask);
  refreshTask()

  INR.subscribe("mpprevweek",function(){
    range = getWeekRange(range.prev)
    displayWeek()
  })
  INR.subscribe("mpnextweek",function(){
    range = getWeekRange(range.next)
    displayWeek()
  })


  INR.subscribe("taskListCreated",function(list){
    defaultList = list;
  });
});

async function refreshTask(){
  const
    [[lists,categoryList,tasks,recipes],settings] = await Promise.all([MetaTaskCache.need(),MealplannerSettingsCache.need()])

  if(defaultList){
    defaultList = TaskListCache.get(defaultList.metaId);
  }
  if(defaultList==null){
    defaultList = TaskListCache.get(settings.defaultAddMealToListId);
  }
  if(defaultList===null){
    var idx = lists.findIndex(list=>list.systemId===-10);
    defaultList = lists[idx]||lists[0];
  }
  var TPL = await import("../mealplanner/tasklist.mustache")
  Html.setHtml(document.getElementById('task-list'),TPL,{list:defaultList,all:lists});

}

const DomTool = {
  nextSlotDom(item: Element): HTMLElement | null {
    const slot = item.closest('.mp-slot');
    if(!slot) return null;

    let nextSlot = slot.nextElementSibling;
    if(nextSlot && nextSlot.classList.contains('mp-slot')){
      return nextSlot as HTMLElement;
    }

    // Si pas de sibling, aller au parent suivant
    const parent = slot.parentElement?.nextElementSibling;
    if(parent){
      return parent.querySelector('.mp-slot');
    }
    return null;
  },
  prevSlotDom(item: Element): HTMLElement | null {
    const slot = item.closest('.mp-slot');
    if(!slot) return null;

    let prevSlot = slot.previousElementSibling;
    if(prevSlot && prevSlot.classList.contains('mp-slot')){
      return prevSlot as HTMLElement;
    }

    // Si pas de sibling, aller au parent suivant
    const parent = slot.parentElement?.previousElementSibling;
    if(parent){
      return parent.querySelector('.mp-slot');
    }
    return null;
  }
}
amplify.subscribe('dishCreated',function(dishes){
  const dayKey = dishes[0].date;
  const dishType = dishes[0].type;
  const slotNode = document.querySelector(`tr[date="${dayKey}"] td[dishtypeenum="${dishType}"]`) as HTMLElement;
  const slotData = daysByKey[dayKey].dishByType[dishType];

  dishes.forEach(d=>slotData.push(d));
  if(slotNode){
    Html.setHtml(slotNode,TPL_SLOTCONTENT,slotData);
    slotNode.click();
  }
})

document.addEventListener('click', Html.createDelegateListener('.mp-slot.hover-controller', function(evt, slotElement){
  if((evt.target as HTMLElement).closest('[data-fw-onclick]')) return;

  let input: HTMLInputElement;

  function createFromInput(){
    const slotNode = input.closest(".mp-slot") as HTMLElement;
    if(!slotNode) return;

    const dishType = slotNode.getAttribute('dishTypeEnum');
    const dayKey = slotNode.parentElement?.getAttribute('date');

    ApiServer.mpcreate([input.value],dayKey,dishType,function(createdDishes){
      amplify.publish('dishCreated',createdDishes)
    });
    dishSyncCache.invalidate();
    recipeSyncCache.invalidate();
    amplify.publish("recipeNeedRefresh")
  }

  const div = slotElement.querySelector('div');
  if(!div) return;

  div.classList.add("selected");

  // Create and append input
  const inputEl = document.createElement('input');
  inputEl.type = 'text';
  inputEl.name = 'dish';
  inputEl.style.width = '100%';
  inputEl.setAttribute('list', 'history-data-list');
  div.appendChild(inputEl);
  input = inputEl;

  input.addEventListener('input', function(evt){
    //when we click on a suggestion
    //on chrome evt.inputType and evt.data are undefined
    //on firefox inputType==="insertReplacementText"
    if((evt.inputType===undefined && (evt as any).data===undefined)||evt.inputType==="insertReplacementText"){
      createFromInput();
    }
  });

  input.addEventListener('click', function(evt){
    evt.stopPropagation()
  });

  input.addEventListener('blur', function(){
    this.remove();
    div.classList.remove('selected');
  });

  input.addEventListener('keydown', function(evt){
    if(evt.keyCode===27){ //escape
      this.blur();
      return;
    }
    if(evt.keyCode===13 || evt.keyCode===10 || evt.keyCode===9){ //enter or return or tabulation
      evt.preventDefault();
      if(this.value.trim().length===0){
        if(evt.keyCode===9){ //tabulation
          if(evt.shiftKey){
            const prevSlot = DomTool.prevSlotDom(this); // prev would need implementation
            if(prevSlot) prevSlot.click();
          }else{
            const nextSlot = DomTool.nextSlotDom(this);
            if(nextSlot) nextSlot.click();
          }
        }
        return;
      }
      createFromInput();
    }
  });

  input.focus();
}));


//drag n drop
registerDragStart(".mp-dish, .mp-recipe",async function(ev,dropPromiseBuilder){
  try{
    var
      droppedEvent = await dropPromiseBuilder(this,Array.from(document.querySelectorAll(".mp-slot, #task-list>*")));
  }catch(e){
    return
  }

  var
    dropped = droppedEvent.target as HTMLElement,
    dragDishNode = this,
    isDish = this.classList.contains('mp-dish'),
    metaId = Html.getDomMetaId(this);


  if(dropped.closest('#task-list>*')){
    var
      permission = FwDatas.getPermission("mpadditemtolist")
    if(permission!=="mpadditemtolist" ){
      if(permission){
        Html.trigger(null,permission)
      }
      return;
    }
    ApiServer.mpadditemtolist([new ApiServer.types.ShoppingIngredientInputBean({
      dishMetaId:metaId
    })],Html.getDomMetaId(dropped));
    amplify.publish("taskNeedRefresh");
  }else{
    var
      dishTypeTarget = dropped.getAttribute('dishTypeEnum'),
      dayKeyTarget = dropped.parentElement.getAttribute('date'),
      slotDataTarget = daysByKey[dayKeyTarget].dishByType[dishTypeTarget];

    if(isDish){
      var
        prevSlotNode = dragDishNode.closest<HTMLElement>(".mp-slot"),
        dishType = prevSlotNode.getAttribute('dishTypeEnum'),
        dayKey = prevSlotNode.parentElement.getAttribute('date'),
        slotData = daysByKey[dayKey].dishByType[dishType];

      slotData.removeMetaId(metaId)
      Html.setHtml(prevSlotNode,TPL_SLOTCONTENT,slotData);
    }


    ApiServer.mpmove([metaId],dayKeyTarget,dishTypeTarget,function(newDishes){
      newDishes.forEach(newDish=>slotDataTarget.push(newDish));
      Html.setHtml(dropped,TPL_SLOTCONTENT,slotDataTarget);
    });
    dishSyncCache.invalidate();
  }

});